export default "__VITE_ASSET__CQtcco0$__"